import { SUPABASE_URL } from "@/integrations/supabase/client";
import { apiFetch } from "@/lib/api-fetch";

export interface ApprovalExitDraft {
  id: string;
  freelancer_id: string;
  freelancer_nome: string | null;
}

/** A candidate the approval closed out ("Vaga preenchida") who goes back to the stage they left. */
export interface ApprovalExitCandidate {
  posicao_id: string;
  freelancer_id: string | null;
  freelancer_nome: string | null;
  etapa_id: string;
  etapa_nome: string;
}

export interface ApprovalExitPreview {
  vaga_id: string;
  /** Why the vaga cannot leave Aprovado (started project, draft in a proposal); null when it can. */
  bloqueio: string | null;
  rascunhos: ApprovalExitDraft[];
  candidatos_restaurados: ApprovalExitCandidate[];
}

export interface ApprovalExitInput {
  status_destino: string;
  tipo_reprovacao?: string;
  reprovado_por?: "corisco" | "cliente";
  motivo_reprovacao?: string;
}

export interface ApprovalExitResult {
  vaga_id: string;
  status: string;
  rascunhos_excluidos: ApprovalExitDraft[];
  avaliacoes_excluidas: number;
  eventos_preterido_excluidos: number;
  candidatos_restaurados: ApprovalExitCandidate[];
}

const exitUrl = (vagaId: string) => `${SUPABASE_URL}v3/vagas/${vagaId}/sair-de-aprovado`;

export const vagaApprovalExitApi = {
  preview: (vagaId: string) => apiFetch<ApprovalExitPreview>(exitUrl(vagaId)),

  apply: (vagaId: string, input: ApprovalExitInput) =>
    apiFetch<ApprovalExitResult>(exitUrl(vagaId), { method: "POST", body: JSON.stringify(input) }),
};
